<template>
    <div class="pane-template" v-if="tools.currentPaneKey === 'item'">
        <pane-header
            :title="item.title"
            :subtitle="item.sub"
            :tools="tools"
            v-if="!hideHeader"
            :appIconKey="item.type"
            :hasCloseIcon="true"
        />
        <ui-scrollable-container>
            <pane-content>
                <ui-details :title="item.name" :list="[
                    {
                        label: 'Status',
                        value: item.status,
                    },
                    {
                        label: 'Barcode',
                        value: item.barcode,
                    },
                    {
                        label: 'Loan type (permanent)',
                        value: item.loan_type_permanent,
                    },
                    {
                        label: 'Location (permanent)',
                        value: item.location_type_permanent,
                    },
                    {
                        label: 'Call Number',
                        value: item.call_number,
                    },
                    {
                        label: 'Material type',
                        value: item.material_type,
                    },
                    {
                        label: 'Loan type (temporary)',
                        value: item.loan_type_temporary,
                    },
                    {
                        label: 'Location (temporary)',
                        value: item.location_type_temporary,
                    },
                ]"></ui-details>
                <pane-section title="Related orders" preset="order" :itemCount="1" :tools="tools" />
                <pane-section title="Related instances" :itemCount="item.instanceCount" preset="instance" :tools="tools" />
            </pane-content>
        </ui-scrollable-container>
    </div>
</template>

<script>
    export default {
        name: 'pane-item-template',
        props: ['tools', 'hideHeader'],
        computed: {
            item() {
                return this.tools.currentView.data.pane;
            },
        },
    };
</script>



// WEBPACK FOOTER //
// ItemPaneTemplate.vue?afcbdee0